<template>
	<div class="container">

		<div class="refundinformation">
			<div class="item">退款信息</div>
			<div class="commodity">
				<div class="commodity-img">
					<div class="comimg">
						<img src="https://gd1.alicdn.com/imgextra/i2/0/O1CN014khwfT1CPvscuaIyU_!!0-item_pic.jpg_400x400.jpg" alt="" width="100%">
					</div>
					<div class="commodity-content">
						<span class="title">30 MONTAIGNE MITZAH 丝巾</span>
						<span class="text">黑色和米白色桑蚕丝斜纹</span>
						<span class="count">x1</span>
					</div>
				</div>
				<div class="commodity-information">
					<div class="cominformation">
						<span class="comtime">申请时间：</span>
						<span class="comdate">2020-10-28 12:00:00</span>
					</div>
					<div class="cominformation">
						<span class="comtime">处理方式：</span>
						<span class="comdate">退货退款</span>
					</div>
					<div class="cominformation">
						<span class="comtime">退款金额：</span>
						<span class="comdate">¥1,990.00</span>
					</div>
					<div class="cominformation">
						<span class="comtime">退款原因：</span>
						<span class="comdate">货物损坏</span>
					</div>
					<!-- <div class="cominformation">
						<span class="comtime">退款说明：</span>
						<span class="comdate">货物破损货物破损货物破损货物破损货物破损货物破损</span>
					</div> -->

				</div>
			</div>
		</div>
		<div class="logistics">
			<div class="items">
				<div class="item-span">
					物流公司
				</div>
				<div class="item-input">
					<input type="text" placeholder="请填写物流公司" class="input">
				</div>
			</div>
			<div class="xian"></div>
			<div class="items">
				<div class="item-span">
					物流公司
				</div>
				<div class="item-input">
					<input type="text" placeholder="请填写物流公司" class="input">
				</div>
			</div>
			
		</div>
		<div class="btn">确定提交</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				value: ''
			};
		},
		methods: {

		},
	};
</script>

<style scoped lang="scss">
	.container {
		height: 100%;
		.logistics {
			padding: 0 20px;
			background-color: #fff;
			margin-bottom: 20px;
			.xian{
				width: 710px;
				height: 1px;
				border: 1px solid #999999;
			}

			.items {
				display: flex;
				padding: 30px 20px;
				

				.item-span,
				.item-input {
					flex: 1;
				}

				.item-span {
					font-size: 28px;
					font-weight: 500;
					color: #333333;
					line-height: 40px;
				}

				.input {
					-webkit-box-pack: end;
					-webkit-justify-content: flex-end;
					justify-content: flex-end;
					text-align: right;
					font-size: 28px;
					font-weight: 500;
					color: #999999;
					line-height: 40px;
					border: 0;
				}
			}

			.loginformation {
				padding: 30px 0 20px 20px;

				.logmatinon {
					padding-bottom: 10px;
					display: flex;

					span {
						display: block;
						font-size: 28px;
						font-weight: 500;
						color: #333333;
						line-height: 40px;
					}

					.logtime {
						padding-right: 20px;
					}
				}


			}
		}

		.refundinformation {
			background: #fff;
			padding: 0 20px;
			margin-bottom: 20px;

			.item {
				padding: 30px 0 14px 20px;
				font-size: 28px;
				font-weight: 500;
				color: #333333;
				line-height: 40px;
				border-bottom: 1px solid #999999;
			}

			.commodity {
				padding: 14px 20px 80px 20px;

				.commodity-img {
					display: flex;

					span {
						display: block;
					}

					.commodity-content {
						flex: 2;
						padding-left: 20px;

						.title {
							font-size: 28px;
							font-weight: 500;
							color: #333333;
							line-height: 40px;
							padding-bottom: 10px;
						}

						.text {
							font-size: 26px;
							font-weight: 500;
							color: #999999;
							line-height: 37px;
							padding-bottom: 33px;
						}

						.count {
							font-size: 28px;
							font-weight: 500;
							color: #333333;
							line-height: 40px;
							text-align: right;
						}
					}

					.comimg {

						width: 180px;
						height: 180px;

						img {
							border-radius: 8px;
						}

					}
				}

				.commodity-information {
					padding-top: 40px;

					.cominformation {
						display: flex;
						padding-bottom: 20px;

						span {
							display: block;
							font-size: 28px;
							font-weight: 500;
							color: #333333;
							line-height: 40px;
						}

						.comtime {
							// flex: 1;
							padding-right: 60px;
						}

						.comdate {
							flex: 2;
						}
					}
				}
			}

		}
		.btn{
			width: 580px;
			height: 88px;
			margin: 0 auto;
			line-height: 88px;
			background: #1e53a4;
			border-radius: 44px;
			font-size: 36px;
			font-weight: 500;
			text-align: center;
			color: #ffffff;
			position: fixed;
			left: 50%;
			transform: translate(-50%,0);
			bottom: 30px;
		}
	}
</style>
